module.exports = __webpack_public_path__ + "src/img/artist/artistpage3.svg?eb31a6f8f5a85299cb539624303aeb73";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage3.svg
// module id = 121
// module chunks = 0